import React from 'react';
import { withTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core';

import Avatar from 'common/Avatar';

import CommunicationIcon from 'images/icons/communication.svg';
import LeaderIcon from 'images/icons/leader.svg';
import OrdersIcon from 'images/icons/orders.svg';
import FabricIcon from 'images/icons/components/icn-type-fabrick-white.svg';
import SpecificationParametersIcon from 'images/icons/icn-organization.svg';

import SidebarLink from './SidebarLink';

import './sidebar.scss';
import DefaultCountrySelectBox from './DefaultCountrySelectBox';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const Sidebar = ({ t }) => {
  const classes = useStyles();

  return (
    <div className={`sidebar ${classes.root}`}>
      <Avatar notificationNumber={32} />
      <DefaultCountrySelectBox />
      <div className="sidebar__navigation">
        <SidebarLink linkTo="/specifications" title={t('specifications')} icon={<LeaderIcon />} />
        <SidebarLink linkTo="/orders" title={t('orders')} icon={<OrdersIcon />} />
        <SidebarLink
          linkTo="/warehouse-releases"
          title={t('warehouse_releases')}
          icon={<CommunicationIcon />}
        />
        <SidebarLink linkTo="/organization" title={t('components_library')} icon={<FabricIcon />} />
        <SidebarLink
          linkTo="/specification-parameters"
          title={t('administration')}
          icon={<SpecificationParametersIcon />}
        />
      </div>
    </div>
  );
};

export default withTranslation()(Sidebar);
